import { useState } from 'react';
import { casosClinicos } from '../../../mocks/casosClinicos';

export default function CasosClinicos() {
  const [activeCase, setActiveCase] = useState<number | null>(null);

  return (
    <section id="casos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between mb-16">
          <h2 className="text-5xl font-bold text-petrol-700">Casos Clínicos Reales</h2>
          <span className="bg-olive-100 text-olive-600 px-6 py-2 rounded-full font-semibold whitespace-nowrap">
            Transformaciones Verificadas
          </span>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {casosClinicos.map((caso, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={activeCase === index ? caso.imagenDespues : caso.imagenAntes}
                  alt={activeCase === index ? 'Después del tratamiento' : 'Antes del tratamiento'}
                  className="w-full h-full object-cover object-top transition-all duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
                  {activeCase === index ? 'Después' : 'Antes'}
                </div>
                <button
                  onClick={() => setActiveCase(activeCase === index ? null : index)}
                  className="absolute bottom-4 right-4 bg-olive-500 hover:bg-olive-600 text-white px-6 py-2 rounded-full text-sm font-semibold shadow-lg transition-all duration-300 flex items-center space-x-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-arrow-left-right-line"></i>
                  <span>{activeCase === index ? 'Ver Antes' : 'Ver Después'}</span>
                </button>
              </div>

              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="bg-sky-100 text-petrol-600 px-4 py-1 rounded-full text-sm font-semibold">
                    {caso.tipo}
                  </span>
                  <span className="text-petrol-400 text-sm">{caso.duracion}</span>
                </div>

                <div className="flex items-center justify-between mb-4">
                  <div className="text-sm text-petrol-500">
                    <span className="font-semibold">Edad:</span> {caso.edad}
                  </div>
                  <div className="flex items-center space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <i 
                        key={i}
                        className={`ri-star-${i < caso.complejidad ? 'fill' : 'line'} text-olive-400 text-sm`}
                      ></i>
                    ))}
                  </div>
                </div>

                <p className="text-petrol-500 text-sm mb-4 leading-relaxed">{caso.descripcion}</p>

                <div className="flex items-center space-x-3 pt-4 border-t border-gray-100">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center">
                    <img 
                      src={caso.doctorAvatar}
                      alt={caso.doctor}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-petrol-700">{caso.doctor}</div>
                    <div className="text-xs text-petrol-400">Ortodoncista</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
